(function () {
  function init(root) {
    // Szuflada i overlay muszą leżeć poza kontenerem produktu: jego przodek
    // (section.wt-product__main) ma position:sticky + z-index, co tworzy
    // osobny kontekst stackowania i header/pasek ogłoszeń sklepu przykrywał
    // górę szuflady. Przenosimy je do <body>.
    var portal = document.createElement('div');
    portal.className = 'mds-portal';
    ['[data-mds-overlay]', '[data-mds-drawer]'].forEach(function (sel) {
      var el = root.querySelector(sel);
      if (el) portal.appendChild(el);
    });
    document.body.appendChild(portal);
    var $ = function (s) { return root.querySelector(s) || portal.querySelector(s); };
    var $$ = function (s) {
      return Array.prototype.slice.call(root.querySelectorAll(s))
        .concat(Array.prototype.slice.call(portal.querySelectorAll(s)));
    };
    var drawer = $('[data-mds-drawer]'), overlay = $('[data-mds-overlay]');
    var days = root.dataset.days.split(',').map(Number);          // 1=pn..7=nd
    var times = root.dataset.times.split(',');
    var weeks = +root.dataset.weeks, lead = +root.dataset.lead;
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var minDate = new Date(today); minDate.setDate(minDate.getDate() + lead);
    var maxDate = new Date(today); maxDate.setDate(maxDate.getDate() + weeks * 7);
    var view = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
    var state = { date: null, time: null };
    var lastFocus = null;
    var fmt = new Intl.DateTimeFormat('pl-PL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });

    function step(n) {
      $$('[data-mds-step]').forEach(function (s) { s.hidden = s.dataset.mdsStep !== String(n); });
      $('.mds__body').scrollTop = 0;
    }
    function open() {
      lastFocus = document.activeElement;
      overlay.hidden = false; drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.body.classList.add('mds-lock');
      step(1);
      var c = $('.mds__close'); if (c) c.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('mds-lock');
      setTimeout(function () { drawer.hidden = true; overlay.hidden = true; }, 250);
      if (lastFocus) lastFocus.focus();
    }
    function iso(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
    function ok(d) { var dow = d.getDay() || 7; return d >= minDate && d <= maxDate && days.indexOf(dow) > -1; }

    function render() {
      var grid = $('[data-mds-grid]'); grid.innerHTML = '';
      $('[data-mds-month]').textContent = new Intl.DateTimeFormat('pl-PL', { month: 'long', year: 'numeric' }).format(view);
      ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'Nd'].forEach(function (n) {
        var e = document.createElement('div'); e.className = 'mds__dow'; e.textContent = n; grid.appendChild(e);
      });
      var first = new Date(view.getFullYear(), view.getMonth(), 1);
      var offset = ((first.getDay() || 7) - 1);
      for (var i = 0; i < offset; i++) grid.appendChild(document.createElement('div'));
      var last = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      for (var n = 1; n <= last; n++) {
        var d = new Date(view.getFullYear(), view.getMonth(), n);
        var b = document.createElement('button'); b.type = 'button'; b.className = 'mds__day'; b.textContent = n;
        if (!ok(d)) b.disabled = true;
        if (state.date && iso(d) === iso(state.date)) b.classList.add('is-sel');
        (function (dd) { b.addEventListener('click', function () { state.date = dd; state.time = null; render(); renderTimes(); update(); }); })(d);
        grid.appendChild(b);
      }
      $('[data-mds-prev]').disabled = view <= new Date(minDate.getFullYear(), minDate.getMonth(), 1);
      $('[data-mds-nextm]').disabled = view >= new Date(maxDate.getFullYear(), maxDate.getMonth(), 1);
    }
    function renderTimes() {
      var box = $('[data-mds-times]'), list = $('[data-mds-timelist]'); list.innerHTML = '';
      box.hidden = !state.date;
      times.forEach(function (t) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'mds__time'; b.textContent = t;
        if (state.time === t) b.classList.add('is-sel');
        b.addEventListener('click', function () { state.time = t; renderTimes(); update(); });
        list.appendChild(b);
      });
    }
    function type() { return $('input[name=mds_type]:checked').value; }
    function update() { $('[data-mds-to-form]').disabled = !(state.date && state.time); }
    function term() { return fmt.format(state.date) + ', godz. ' + state.time; }

    $$('[data-mds-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-mds-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
    $('[data-mds-next]').addEventListener('click', function () { render(); renderTimes(); step(2); });
    $('[data-mds-prev]').addEventListener('click', function () { view = new Date(view.getFullYear(), view.getMonth() - 1, 1); render(); });
    $('[data-mds-nextm]').addEventListener('click', function () { view = new Date(view.getFullYear(), view.getMonth() + 1, 1); render(); });
    $$('[data-mds-back]').forEach(function (b) { b.addEventListener('click', function () { step(b.dataset.mdsBack); }); });
    $('[data-mds-to-form]').addEventListener('click', function () {
      $('[data-mds-summary]').textContent = type() + ': ' + term();
      $('[data-mds-f-type]').value = type();
      $('[data-mds-f-term]').value = term();
      step(3);
    });

    var form = $('#mds-form');
    var KEY = 'mds_last';
    // Sklep ma włączoną captchę Shopify (hCaptcha), której token dokłada
    // skrypt Shopify przy NATYWNYM wysłaniu formularza. Wysyłka przez fetch
    // kończy się błędem 400 "Missing CAPTCHA token", a ukryty iframe jest
    // zablokowany przez X-Frame-Options: DENY. Dlatego formularz wysyłamy
    // normalnie; Shopify wraca na tę samą stronę z ?contact_posted=true,
    // a my wtedy otwieramy szufladę od razu na ekranie "Dziękujemy".
    form.addEventListener('submit', function () {
      try { sessionStorage.setItem(KEY, JSON.stringify({ type: type(), term: term() })); } catch (e) {}
      form.querySelector('button[type=submit]').disabled = true;
    });
    try {
      var last = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (last && /[?&]contact_posted=true/.test(location.search)) {
        sessionStorage.removeItem(KEY);
        history.replaceState(null, '', location.pathname + location.search.replace(/([?&])contact_posted=true&?/, '$1').replace(/[?&]$/, '') + location.hash);
        lastFocus = null;
        overlay.hidden = false; drawer.hidden = false;
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        document.body.classList.add('mds-lock');
        $('[data-mds-done]').textContent = last.type + ': ' + last.term + '.';
        step(4);
      }
    } catch (e) {}
  }
  function boot() { document.querySelectorAll('[data-mds]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
